import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Checkbox, Select, MenuItem } from '@mui/material';
import { getTagName } from 'components/Input/KoujiTagComponent';
import SelectComponent from 'components/Input/SelectComponent';

// 工事タグ選択コンポーネント
export const KoujiTagSelectComponent = (props) => {
  const labels = props.labels;
  const tagTypes = props.tagTypes ?? [];

  // タグの種類
  const [tagType, setTagType] = useState({});

  // 選択中のタグ
  const [selectedTags, setSelectedTags] = useState([]);

  // タグ種別の編集処理
  const handleOnChangeTagType = (event) => {
    const _tagType = event.value;
    setSelectedTags([]);
    setTagType(tagTypes.find((x) => x.TAG_TYPE == _tagType));
  };

  // 編集処理
  const handleOnChangeMain = (value) => {
    setSelectedTags(value);
  };

  // タグ名を表示
  const getSelectedTagNames = () => {
    return selectedTags.map((t) => getTagName(labels, t)).join('、');
  };

  // 追加ボタン押下
  const handleOnClickAdd = (code) => {
    props.callAddTag(selectedTags);
    setTagType({ TAG_TYPE: '' });
    setSelectedTags([]);
  };

  return (
    <div style={{ display: 'flex' }}>
      <SelectComponent
        className="kouji-tag-select"
        value={tagType?.TAG_TYPE}
        onChange={handleOnChangeTagType}
      >
        <option key={0} value={''}>
          {'　'}
        </option>
        {tagTypes.map((x) => (
          <option key={x.TAG_TYPE} value={x.TAG_TYPE}>
            {x.TAG_NAME}
          </option>
        ))}
      </SelectComponent>
      {tagType?.TAG_TYPE && (
        <Select
          multiple
          displayEmpty
          className="ml-2"
          style={{ height: '38px', width: '320px' }}
          variant="standard"
          value={selectedTags}
          renderValue={(x) => {
            if (x.length === 0) {
              return (
                <em className="pl-2" style={{ color: '#ababab' }}>
                  {tagType?.TAG_NAME}タグを選択
                </em>
              );
            }
            return <div className="pl-1">{getSelectedTagNames()}</div>;
          }}
          onChange={(e) => {
            handleOnChangeMain(e.target.value);
          }}
        >
          <MenuItem disabled value="">
            <em>{tagType?.TAG_NAME}タグを選択</em>
          </MenuItem>
          {labels
            .filter((x) => x.TAG_TYPE == tagType?.TAG_TYPE)
            .map((x) => (
              <MenuItem key={x.LABEL_CD} value={x.LABEL_CD} className="m-0 p-0">
                <Checkbox
                  checked={selectedTags.indexOf(x.LABEL_CD) > -1}
                  className="m-0 ml-2 p-1"
                />
                <h5 className="m-0 p-0">{x.DISPLAY}</h5>
              </MenuItem>
            ))}
        </Select>
      )}
      <Button
        size="sm"
        disabled={selectedTags.length == 0}
        style={{ width: '48px', height: '32px', marginTop: '5px' }}
        variant="success"
        className="btn-fill ml-2"
        onClick={handleOnClickAdd}
      >
        追加
      </Button>
    </div>
  );
};
